import { log } from 'log';
import { getBaseDomain } from '@theme/js/utils/url.util';

export const init = (): void => {
    const domain = getBaseDomain({ dotStart: false });

    log('info', '[UCIP]: Init');

    try {
        document.domain = domain;

        log('info', '[UCIP]: Domain was changed to ', domain);
    } catch (e) {
        log('error', '[UCIP]: Cannot change domain to ', domain);
    }
};
